import React from "react";
import { API } from "../config/config";
import axios from "axios";
import Button from "components/CustomButtons/Button.jsx";
import Grid from "@material-ui/core/Grid";
import PersianCalender from "../datepicker";
import BootMulti from "../AllMarket/bootMulti";
import { Collapse, Button as BootButton, Form } from "react-bootstrap";

export default class AllPosts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      states: [],
      factories: [],
      max: null,
      min: null,
      areas: [],
      factory: "",
      state: "",
      status: "",
      categories: [],
      category: "",
      degrees: "",
      degree: "",
      defaultdate: null,
      selectStatus: [
        { label: "ثابت", value: 1 },
        { label: "کاهش", value: 2 },
        { label: "افزایش", value: 3 }
      ],
      selectAreas: [
        { label: "شمال", value: 1 },
        { label: "جنوب", value: 2 },
        { label: "شرق", value: 3 },
        { label: "غرب", value: 4 },
        { label: "مرکز", value: 5 }
      ],
      expand: false
    };
  }

  async componentDidMount() {
    try {
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        withCredentials: false,
        credentials: "same-origin",
        url: API + "/api/States/GetStates"
      };

      let response = await axios(options);
      if (response.status === 200) {
        const rows = [];

        response.data.results.map(row =>
          rows.push({ label: row.name, value: row.id })
        );

        await this.setState({ states: rows });
      }
    } catch (err) {
      await this.setState({
        message_error:
          "متاسفانه مشکلی در دریافت اطلاعات بوجود آمده لطفا دوباره سعی نمایید."
      });
    }
    try {
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        withCredentials: false,
        credentials: "same-origin",
        url: API + "/api/Factories/GetFactories"
      };

      let responsefactory = await axios(options);
      // console.log(responsefactory)
      if (responsefactory.status === 200) {
        const rows = [];

        responsefactory.data.results.map(row =>
          rows.push({ label: row.name, value: row.id })
        );

        await this.setState({ factories: rows });
      }
    } catch (err) {
      await this.setState({
        message_error:
          "متاسفانه مشکلی در دریافت اطلاعات بوجود آمده لطفا دوباره سعی نمایید."
      });
    }
    try {
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        withCredentials: false,
        credentials: "same-origin",
        url: API + "/api/Categories/GetCategories"
      };

      let responsecategory = await axios(options);
      // console.log(responsecategory)
      if (responsecategory.status === 200) {
        const categories = [];
        responsecategory.data.results.map(category => {
          if (categories.filter(i => i.label === category.name).length === 0)
            categories.push({ label: category.name, value: category.id });
          return true;
        });
        await this.setState({ categories: categories });
      }
    } catch (err) {
      await this.setState({
        message_error:
          "متاسفانه مشکلی در دریافت اطلاعات بوجود آمده لطفا دوباره سعی نمایید."
      });
    }
  }

  async FromDate(e) {
    await this.setState({ defaultdate: e });
  }
  async getarea(e) {
    await this.setState({ areas: e });
  }
  async getfactory(e) {
    await this.setState({ factory: e });
  }
  async getstates(e) {
    await this.setState({ state: e });
  }
  async getstatus(e) {
    await this.setState({ status: e });
  }
  async getcategory(e) {
    await this.setState({ category: e });
  }
  async handelgrade(e) {
    console.log(e.target.value);
    await this.setState({ degree: e.target.value });
  }
  async search() {
    this.setState({ expand: false });
    const {
      defaultdate,
      areas,
      factory,
      state,
      status,
      category,
      degree
    } = this.state;
    let smin = defaultdate;
    let sareas = areas;
    let sfactory = factory;
    let sstate = state;
    let sstatus = status;
    let scategory = category;
    let sdegree = degree;

    if (areas.length === 0) {
      sareas = null;
    }
    if (status.length === 0) {
      sstatus = null;
    }
    if (state === "" || state === undefined) {
      sstate = null;
    }
    if (factory === "" || factory === undefined) {
      sfactory = null;
    }
    if (category === "" || category === undefined) {
      scategory = null;
    }
    if (degree === "" || degree === undefined) {
      sdegree = null;
    }
    const posturl = [
      { name: "credit_date_min", value: smin, arr: false },
      { name: "factory_id", value: sfactory, arr: false },
      { name: "grade_name", value: sdegree, arr: false },
      { name: "category_ids", value: scategory, arr: true },
      { name: "state_ids", value: sstate, arr: true },
      { name: "status_ids", value: sstatus, arr: true },
      { name: "area_ids", value: sareas, arr: true }
    ];
    let search = "";

    posturl.map(result => {
      if (result.value !== null) {
        if (result.arr === false) {
          search += result.name + "=" + result.value + "&";
        } else {
          result.value.map(arr => {
            search += result.name + "[]=" + arr + "&";
            return true;
          });
        }
      }
      return true;
    });
    const get = search.slice(0, -1);
    this.props.get(get);
  }
  handleExpand() {
    this.setState({ expand: !this.state.expand });
  }
  render() {
    const {
      factories,
      states,
      categories,
      selectStatus,
      selectAreas,
      expand
    } = this.state;
    // console.log("categories", categories);
    return (
      <div className="search-post">
        <div className="cloapsediv">
          <BootButton
            onClick={() => this.setState({ expand: !expand })}
            aria-controls="example-collapse-text"
            aria-expanded={expand}
            className="cloapsbut"
          >
            سبا
          </BootButton>
          <div
            className="colapscontent"
            onClick={() => this.setState({ expand: !expand })}
            style={{ cursor: "pointer" }}
          >
            <span>جستجو...</span>
          </div>
          <Collapse in={expand}>
            <div id="example-collapse-text" className="colapsemaindiv">
              <Grid container className={"search-main-grid"} spacing={2}>
                <Grid item xs={12} md={6} className="ex-detail-grid">
                  <BootMulti
                    menus={states}
                    getData={this.getstates.bind(this)}
                    label="محل استان کارخانه"
                    isMulti={true}
                  />
                </Grid>
                <Grid item xs={12} md={6} className="ex-detail-grid">
                  <BootMulti
                    menus={factories}
                    getData={this.getfactory.bind(this)}
                    label="کارخانه"
                    isMulti={false}
                  />
                </Grid>
                <Grid item xs={12} md={6} className="ex-detail-grid">
                  <BootMulti
                    menus={selectAreas}
                    getData={this.getarea.bind(this)}
                    label="ناحیه"
                    isMulti={true}
                  />
                </Grid>
                <Grid item xs={12} md={6} className="ex-detail-grid">
                  <BootMulti
                    menus={selectStatus}
                    getData={this.getstatus.bind(this)}
                    label="وضعیت"
                    isMulti={true}
                  />
                </Grid>
                <Grid item xs={12} md={6} className="ex-detail-grid">
                  <BootMulti
                    menus={categories}
                    getData={this.getcategory.bind(this)}
                    label="رسته"
                    isMulti={true}
                  />
                </Grid>
                <Grid item xs={12} md={6} className="ex-detail-grid">
                  <PersianCalender getDate={this.FromDate.bind(this)} />
                </Grid>
                <Grid item xs={12} md={6} className="ex-detail-grid">
                  <Form.Control
                    placeholder="درجه"
                    onChange={this.handelgrade.bind(this)}
                    style={{
                      fontSize: "15px",
                      fontFamily: "dirooz",
                      padding: "5px 10px",
                      borderRadius: "5px",
                      border: "1px solid #cacaca",
                      width: "100%",
                      color: "#7d7d7d"
                    }}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} md={12} className="ex-detail-grid">
                <Button className="search-but" onClick={this.search.bind(this)}>
                  جستجو
                </Button>
                <Button
                  className="search-but"
                  onClick={() => window.location.replace("/posts")}
                >
                  حذف جستجو
                </Button>
              </Grid>
            </div>
          </Collapse>
        </div>
      </div>
    );
  }
}
